// src/pages/SettingsPage.tsx — настройки: боковая навигация по группам, поиск, ссылка на раздел в адресе
import React, { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import SettingsNav, { NAV_GROUPS, allNavItems } from "../components/settings/SettingsNav";
import SettingsContent from "../components/settings/SettingsContent";
import { usePermissions } from "../hooks/usePermissions";
import api from "../api/axios";
import "../styles/settings/settings.css";
import "../styles/settings/settings-nav.css";

function getRoleFromToken(): string {
  try {
    const token = localStorage.getItem("token");
    if (!token) return "EMPLOYEE";
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.role ?? "EMPLOYEE";
  } catch {
    return "EMPLOYEE";
  }
}

export default function SettingsPage() {
  const perms = usePermissions();
  const role = getRoleFromToken();
  const [params, setParams] = useSearchParams();
  const [status, setStatus] = useState<Record<string, boolean>>({});

  const items = useMemo(() => allNavItems(role), [role]);
  const wanted = params.get("tab") || localStorage.getItem("settings.tab") || "";
  const fallback = items.find((i) => i.id === perms.settingsTabs[0])?.id ?? items[0]?.id ?? "pipeline";
  const active = items.some((i) => i.id === wanted) ? wanted : fallback;

  const choose = (id: string) => {
    try { localStorage.setItem("settings.tab", id); } catch { /* приватный режим */ }
    setParams({ tab: id }, { replace: true });
  };

  // индикаторы «подключено» у интеграций (список доступен руководителю и администратору)
  useEffect(() => {
    if (role !== "ADMIN" && role !== "OFFICE_LEAD") return;
    api.get("/integrations")
      .then((r) => {
        const m: Record<string, boolean> = {};
        (Array.isArray(r.data) ? r.data : []).forEach((i: any) => { m[i.name] = i.enabled !== false; });
        setStatus(m);
      })
      .catch(() => undefined);
  }, [role]);

  const current = items.find((i) => i.id === active);
  const group = NAV_GROUPS.find((g) => g.items.some((i) => i.id === active));

  return (
    <div className="settings-page st2-page">
      <div className="st2-layout">
        <SettingsNav role={role} active={active} onChange={choose} status={status} />
        <section className="st2-main">
          {current && (
            <div className="st2-head">
              <div className="st2-crumb">
                {group?.title} <span>›</span> <b>{current.label}</b>
              </div>
              <div className="st2-desc">{current.desc}</div>
            </div>
          )}
          <div className="settings-content-wrapper st2-wrap">
            <SettingsContent key={active} section={active} role={role} />
          </div>
        </section>
      </div>
    </div>
  );
}
